// extracted by mini-css-extract-plugin
export var aggregationCell = "_2j-m";
export var aggregationRow = "_2j-l";
export var borderlessSpinnerContainer = "_2j-3";
export var cardLayout = "_2j-6";
export var cardLayoutPageControl = "_2j-7";
export var closeIcon = "_2j-e";
export var columnHeaderSurface = "_2j-a";
export var columnHeaderSurfaceDragOverlay = "_2j-u";
export var columnHeaderSurfaceResizing = "_2j-r";
export var contextMenuAnchor = "_2j-1";
export var draggableColumnHeader = "_2j-s";
export var draggableColumnHeaderOverlay = "_2j-t";
export var expandIcon = "_2j-f";
export var expanded = "_2j-g";
export var filterDropdown = "_2j-h";
export var filterDropdownDivider = "_2j-c";
export var filterDropdownHeader = "_2j-k";
export var filterDropdownItem = "_2j-j";
export var filterDropdownModal = "_2j-i _2j-h";
export var filterItem = "_2j-b";
export var normalCellWithAdjustableBorder = "_2j-d";
export var pinButtonContainer = "_2j-n";
export var pinIcon = "_2j-o";
export var pinIconActive = "_2j-p";
export var spinner = "_2j-0";
export var spinnerContainer = "_2j-2";
export var tableContainer = "_2j-4";
export var tableContentDraggingColumns = "_2j-9";
export var tableContentInner = "_2j-8";
export var tableContentWrapper = "_2j-5";
export var viewButtonContainer = "_2j-q";